export const ENGLISH = 'en';
export const FRENCH = 'fr';
export const CHINESE = 'zh';
